import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@fluentui/react';
import { useHistory, useLocation } from 'react-router-dom';
/**
 * Enhances Fluent UI’s `Link` component with React Router’s `history`
 * making it easier to add in-app navigation without defining `onClick` and `useHistory` every time.
 *
 * Since this component relies on `useHistory`, it will need React Router’s `BrowserRouter` as an ancestor.
 */
const AppLink = (props) => {
    const { push } = useHistory();
    const location = useLocation();
    return (_jsx(Link, Object.assign({}, props, { onClick: event => {
            event.preventDefault();
            push(Object.assign(Object.assign({}, location), { pathname: props.href }));
        } })));
};
// Exports
// -------
export { AppLink };
